<template>
  <v-app style="background-color: black">
    <div v-if="isLoading">
      <LoadingPageComponent />
    </div>
    <div v-else>
      <HeaderComponent />
      <v-main class="pa-0">
        <router-view />
      </v-main>
      <FooterComponent />
    </div>

    <!--
      CookieConsentSlider is conflicting with CallToAttach
      The solution is to give them a shared signal.  In this case, both
      will show based on properties in the Pinia store (see code below)

      // stores/dialog.ts
      import { defineStore } from 'pinia';

      export const useDialogStore = defineStore('dialog', {
        state: () => ({
          cookieDialogOpen: true,    // show cookie sheet on first load
          ctaDialogOpen:   false,   // keep CTA hidden
        }),
        actions: {
          acceptCookies() {
            this.cookieDialogOpen = false;
            this.ctaDialogOpen   = true;
          }
        }
      });
      <CookieConsentSlider />
    -->
    <CookieConsentSlider />
    <CallToAction />
  </v-app>
</template>

<script setup>
  import FooterComponent from '@/components/FooterComponent.vue';
  import HeaderComponent from '@/components/HeaderComponent.vue';
  import CallToAction from '@/components/CallToAction.vue';
  import CookieConsentSlider from '@/components/CookieConsentSlider.vue';
  import LoadingPageComponent from '@/components/LoadingPageComponent.vue';
  import { onMounted, ref } from 'vue';
  import 'vuetify/dist/vuetify.min.css';

  const isLoading = ref(true);
  const hasSeenSplash = sessionStorage.getItem('hasSeenSplash');
  if (!hasSeenSplash) {
    sessionStorage.setItem('hasSeenSplash', 'true');
    isLoading.value = true;
  } else {
    isLoading.value = false;
  }

  onMounted(() => {
    setTimeout(() => {
      isLoading.value = false;
    }, 1);
  });
</script>
